import { actionRequestFactory, actionResponseFactory } from '@factories';
import {
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  GET_USER_ACCOUNT,
  GET_USER_ACCOUNT_SUCCESS,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_SETTINGS_PASSWORD_REQUEST,
  CHANGE_SETTINGS_PASSWORD_SUCCESS,
  CHANGE_SETTINGS_PASSWORD_FAILURE,
  RESET_SETTINGS_PASSWORD,
  VERIFY_CHANGE_PASSWORD_REQUEST,
  INVITE_USER_REQUEST,
  INVITE_USER_SUCCESS,
  INVITE_USER_FAILURE,
  RESET_INVITE_USER_REQUEST,
} from '@store/user/user.const';

export const createUserRequest = (user, existing) =>
  actionRequestFactory(CREATE_USER_REQUEST, { user, existing });
export const createUserSuccess = ({ user, token }) =>
  actionResponseFactory(CREATE_USER_SUCCESS, { user, token });
export const createUserFailure = error => actionResponseFactory(CREATE_USER_FAILURE, { error });

export const getUserAccount = payload => actionRequestFactory(GET_USER_ACCOUNT, payload);
export const getUserAccountSuccess = account =>
  actionResponseFactory(GET_USER_ACCOUNT_SUCCESS, { account });

/* Change password */
export const changePasswordRequest = payload =>
  actionRequestFactory(CHANGE_PASSWORD_REQUEST, payload);

export const changeSettingsPasswordRequest = payload =>
  actionRequestFactory(CHANGE_SETTINGS_PASSWORD_REQUEST, payload);
export const changeSettingsPasswordSuccess = response =>
  actionResponseFactory(CHANGE_SETTINGS_PASSWORD_SUCCESS, { response });
export const changeSettingsPasswordFailure = error =>
  actionResponseFactory(CHANGE_SETTINGS_PASSWORD_FAILURE, { error });
export const resetSettingsPassword = () => actionRequestFactory(RESET_SETTINGS_PASSWORD, null);

/* Validate Change password request */
export const verifyChangePasswordRequest = payload =>
  actionRequestFactory(VERIFY_CHANGE_PASSWORD_REQUEST, payload);

export const inviteUserRequest = payload => actionRequestFactory(INVITE_USER_REQUEST, payload);
export const inviteUserSuccess = response =>
  actionResponseFactory(INVITE_USER_SUCCESS, { response });
export const inviteUserFailure = error => actionResponseFactory(INVITE_USER_FAILURE, { error });
export const resetInviteUserRequest = () => actionRequestFactory(RESET_INVITE_USER_REQUEST);
